module.exports = __webpack_public_path__ + "img/login-hotline-absystech.ab241b46.png";